"use strict";
/*
 * Created on Tue Oct 16 2018
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var AppModule_1 = require("../core/modules/AppModule");

var ThemeConverter_1 = require("./conversions/ThemeConverter");

var ThemeConverterImpl_1 = require("./conversions/ThemeConverterImpl");

var ThemesViewDTOConverter_1 = require("./conversions/ThemesViewDTOConverter");

var ThemesViewDTOConverterImpl_1 = require("./conversions/ThemesViewDTOConverterImpl");
/**
 *
 */


var ThemeAppModule =
/*#__PURE__*/
function (_AppModule_1$AppModul) {
  _inherits(ThemeAppModule, _AppModule_1$AppModul);

  function ThemeAppModule() {
    var _this;

    _classCallCheck(this, ThemeAppModule);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ThemeAppModule).apply(this, arguments));
    /**
     * @inheritDoc
     */

    _this.name = 'themeAppModule';
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(ThemeAppModule, [{
    key: "configure",
    value: function configure() {
      typescript_ioc_1.Container.bind(ThemeConverter_1.ThemeConverter).to(ThemeConverterImpl_1.ThemeConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
      typescript_ioc_1.Container.bind(ThemesViewDTOConverter_1.ThemesViewDTOConverter).to(ThemesViewDTOConverterImpl_1.ThemesViewDTOConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
    }
  }]);

  return ThemeAppModule;
}(AppModule_1.AppModule);

exports.ThemeAppModule = ThemeAppModule;